export default "__VITE_ASSET__BuPEqSP3__"